/* eslint-disable */
import { createSelector } from 'reselect';
import ordersAddressesSelector from './OrderAddress.selector';

/**
 * Select the order address loading
 * @returns {OrderAddressEntity | null} The `order` address loading that has been selected from the store
 */
const ordersAddressesLoadingSelector = createSelector(ordersAddressesSelector, (addresses = {}) => addresses.loading);

export default ordersAddressesLoadingSelector;
